import {loadDevMessages, loadErrorMessages} from "@apollo/client/dev";
import {Constants} from "./constants/constants";
import {OktaAuthOptions} from "@okta/okta-auth-js";
// TODO: Move this to .env
// https://create-react-app.dev/docs/adding-custom-environment-variables/
// https://12factor.net/config

// Environments
export interface Environment {
  name: string;
  okta: {
    clientId: string;
  };
  gqlApiUrl: string;
  servicesApiUrl: string;
  configCatKey: string;
  configCatRefreshInSeconds: number;
  updateCheckInSeconds: number;
  aggridLicenseKey: string;
  sentryDsn: string;
}

const aggridLicenseKey =
  "Using_this_{AG_Grid}_Enterprise_key_{AG-095849}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{e-Courier}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{next-gen}_only_for_{3}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{next-gen}_need_to_be_licensed___{next-gen}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{31_January_2027}____[v3]_[01]_MTgwMTM1MzYwMDAwMA==bc5cfd11bb327b5219f50c3ce068458a";
const sentryDsn = "https://4108f731fe597b27081c7e1a70cef73d@o4509371122647040.ingest.us.sentry.io/4511413956575232";

const prod: Environment = {
  name: "prod",
  okta: {
    clientId: "0oa3mgg0gcI3vXges5d7"
  },
  gqlApiUrl: "https://gql.e-courier.com/graphql",
  servicesApiUrl: "https://api.e-courier.com",
  configCatKey: "yFraCLRBA0qH1-3zZIOFKA/X_pS1R02nU23gER9p0sp1Q",
  configCatRefreshInSeconds: 300,
  updateCheckInSeconds: 1800,
  aggridLicenseKey: aggridLicenseKey,
  sentryDsn: sentryDsn
};

const staging: Environment = {
  name: "staging",
  okta: {
    clientId: "0oa531956lHA3bOpM5d7"
  },
  gqlApiUrl: "https://gql.dispatch.staging.anabasius.net/graphql",
  servicesApiUrl: "https://api.dispatch.staging.anabasius.net",
  configCatKey: "yFraCLRBA0qH1-3zZIOFKA/wFNir9ncdkSR_woiP05fgQ",
  configCatRefreshInSeconds: 300,
  updateCheckInSeconds: 600,
  aggridLicenseKey: aggridLicenseKey,
  sentryDsn: sentryDsn
};

const dev: Environment = {
  name: "dev",
  okta: {
    clientId: "0oa531956lHA3bOpM5d7"
  },
  gqlApiUrl: "https://gql.dispatch.dev.anabasius.net/graphql",
  servicesApiUrl: "https://api.dispatch.dev.anabasius.net",
  configCatKey: "yFraCLRBA0qH1-3zZIOFKA/wFNir9ncdkSR_woiP05fgQ",
  configCatRefreshInSeconds: 300,
  updateCheckInSeconds: 600,
  aggridLicenseKey: aggridLicenseKey,
  sentryDsn: sentryDsn
};

let env: Environment = dev;
const hostname = window.location.hostname;

if (hostname.match(/^dispatch\.(e-courier\.com|anabasius\.net)/)) {
  env = prod;
} else if (hostname === "staging.dispatch.anabasius.net") {
  env = staging;
}

if (env === dev) {
  //apollo error messages in dev
  // Adds messages only in a dev environment
  loadDevMessages();
  loadErrorMessages();
}

// Okta Config
const oktaAuthConfig: OktaAuthOptions = {
  issuer: "https://ecourier.okta.com/oauth2/aus3u2bl237MTIwSx5d7",
  clientId: env.okta.clientId,
  redirectUri: window.location.origin + "/login/callback",
  maxClockSkew: Constants.DEFAULT_MAX_CLOCK_SKEW_SECONDS,
  scopes: ["openid", "profile", "email", "offline_access"],
  devMode: false, //Enable for okta debugging
  services: {
    autoRenew: true,
    autoRemove: false,
    renewOnTabActivation: true,
    tabInactivityDuration: 30 // 30 seconds
  },
  cookies: {
    secure: true
  }
};

// GraphQL Config
const GQL_API_URL = env.gqlApiUrl;
const SERVICES_API_URL = env.servicesApiUrl;
const CONFIG_CAT_KEY = env.configCatKey;
const CONFIG_CAT_REFRESH_INTERVAL = env.configCatRefreshInSeconds;
const REGION = "us-east-1";

export const isTestingEnv = (): boolean => {
  return [dev.name, staging.name].includes(env.name);
};

export {
  env,
  oktaAuthConfig,
  GQL_API_URL,
  SERVICES_API_URL,
  REGION,
  CONFIG_CAT_KEY,
  CONFIG_CAT_REFRESH_INTERVAL,
  prod,
  staging,
  dev
};
